export default __webpack_public_path__ + "static/media/dialog-corner-other.b1353880.svg";